<script>
  export let src;
  export let styles = "";
</script>

<img
  style={styles}
  src="./images/departments/{src}"
  alt={`Icon for ${src.replace(".png", "")}`}
/>

<style>
  /* This styling will change and is a reminder that we need a consistent icon set */
  img {
    width: 100%;
  }
</style>
